import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { enumShipmentState, enumVoyageType } from '@data-layer/enums/lcl';
import { ManagementShipmentModel } from '@data-layer/models/management';
import { enumLclTrackingStates } from '@enum/enumLclTrackingStates';
import { precisionRound } from '@helpers/data-transform.helper';
import { VoyageTotalsModel } from '../../models';

@Component({
  selector: 'voyage-totals',
  templateUrl: './voyage-totals.component.html',
  styleUrls: ['./voyage-totals.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoyageTotalsComponent {
  @Input() public shipments: ManagementShipmentModel[];
  @Input() public totals: { atWarehouse: VoyageTotalsModel; total: VoyageTotalsModel };
  @Input() public voyageType: number;

  public VOYAGE_TYPES: typeof enumVoyageType = enumVoyageType;

  constructor() {}

  public get revenueAtWarehousePrice(): number {
    return precisionRound(
      (this.shipments || [])
        .filter((item: ManagementShipmentModel) => this.isShipmentAtWarehouse(item.trackingState))
        .reduce((accPrice: number, currentShipment: ManagementShipmentModel) => {
          return !this.isShipmentCanceled(currentShipment.state) ? accPrice + currentShipment?.aggregatedStatistics?.totalPrice : accPrice;
        }, 0),
    );
  }

  public get revenueTotalPrice(): number {
    return precisionRound(
      (this.shipments || []).reduce((accPrice: number, currentShipment: ManagementShipmentModel) => {
        return !this.isShipmentCanceled(currentShipment.state) ? accPrice + currentShipment?.aggregatedStatistics?.totalPrice : accPrice;
      }, 0),
    );
  }

  public isShipmentCanceled(state: enumShipmentState): boolean {
    return state === enumShipmentState.CANCELED;
  }

  private isShipmentAtWarehouse(trackingState: enumLclTrackingStates): boolean {
    return trackingState >= enumLclTrackingStates.AT_ORIGIN_WAREHOUSE;
  }
}
